import {
	GetWellBornEligibilityParams,
	GetWellBornEligibilityResponse,
} from 'domain/usecases/private/well-born/get-well-born-eligibility';
import {makeGetWellBornEligibility} from 'main/factories/usecases/private/well-born/get-eligibility';

export async function getWellBornEligibility(
	params: GetWellBornEligibilityParams,
): Promise<GetWellBornEligibilityResponse> {
	const wellBornEligibility = makeGetWellBornEligibility();
	return wellBornEligibility.get(params);
}
